import { AuthenticationService } from 'projects/bimbo/src/app/services/authentication.service';
import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { Employee, Income, PeriodTypeEnum, Parameter, FundParameters, Loan, PayrollParameters, EmployeeRef, LoanParameters, LoanDataLoader, LoanStatus } from '@akiba/models_bimbo';
import { AppState } from '../../../models/appState';
import { Subscription } from 'rxjs';
import * as moment from 'moment';
import { LogicService } from '../../../services/logic.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DataSourceService } from '../../../services/data-source.service';
import { MatDialog } from '@angular/material';
import { RejectDialogComponent } from '../../../dialogs/reject-dialog/reject-dialog.component';
import { CancelConfirmDialogComponent } from '../../../dialogs/cancel-confirm-dialog/cancel-confirm-dialog.component';
import { InfoDialogComponent } from '../../../dialogs/info-dialog/info-dialog.component';
import { take } from 'rxjs/operators';
import { environment } from 'projects/bimbo/src/environments/environment';
import { UiService } from '../../../services/ui.service';
import { PendingLoanRequestLogicService } from '../../../services/pending-loan-request-logic.service';

@Component({
  selector: 'app-loan-approval',
  templateUrl: './loan-approval.component.html',
  styleUrls: ['./loan-approval.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoanApprovalComponent implements OnInit, OnDestroy {

  displayedColumns = ['date', 'amount'];
  currentEmployee: Employee;
  contentLocation: AppState = new AppState();
  //////////////////////////////////////
  principalSubscription: Subscription;
  parameterSubscription: Subscription;
  theoreticalAvailableAmountSubscription: Subscription;
  //////////////////////////////////////
  permanentSavingParameter: Parameter | null = null;
  retirementSavingParameter: Parameter | null = null;
  permanentParameter: Parameter | null = null;
  permanentLoanParameter: LoanParameters | null = null;
  retirementLoanParameter: Parameter | null = null;
  shortFundParameter: FundParameters | null = null;
  longFundParameter: FundParameters | null = null;
  payrollParameter: PayrollParameters | null = null;
  //////////////////////////////////////
  selectedLoan: Loan;
  employeeInfo = '';
  textWage = '';
  payrollContributions: Array<Income>;
  loanID = '';
  period: Parameter;

  constructor(public logicService: LogicService, private route: ActivatedRoute, private router: Router, private dataSource: DataSourceService, public dialog: MatDialog, private authService: AuthenticationService, private ui: UiService, private pendingLoans: PendingLoanRequestLogicService) {

    const loanID = this.route.snapshot.paramMap.get('id');
    this.procID(loanID);

  }

  async procID(loanID: string) {

    const l: any = await this.dataSource.loadLoan(loanID).pipe(take(1)).toPromise();
    this.selectedLoan = new Loan(l);
    const periodObj = await this.dataSource.loadParameterByID(this.selectedLoan.periodId).pipe(take(1)).toPromise();
    this.period = new Parameter(periodObj);

    const emp: any = await this.dataSource.loadEmployee(this.selectedLoan.employeeRef.employeeNumber).pipe(take(1)).toPromise();
    this.currentEmployee = new Employee(emp);

    const parameters = this.logicService.dataManager.parameterDataLoader.parameters ? this.logicService.dataManager.parameterDataLoader.parameters : [];
    const payrollParameters = this.logicService.dataManager.parameterDataLoader.payrolls ? this.logicService.dataManager.parameterDataLoader.payrolls : [];
    this.permanentSavingParameter = parameters.filter(parameterObj => parameterObj.type === PeriodTypeEnum.permanentSaving).find(e => e.savingParameterAppliesTo(this.currentEmployee));
    this.permanentParameter = parameters.filter(parameterObj => parameterObj.type === PeriodTypeEnum.permanentSaving).find(e => e.loanParameterAppliesTo(this.currentEmployee));
    this.permanentLoanParameter = this.permanentParameter ? this.permanentParameter.applicableLoanParameter : new LoanParameters();
    this.payrollParameter = payrollParameters.find(e => e.payrollAppliesTo(this.currentEmployee));


    const values = this.currentEmployee.workInformation.wage.historical.values();
    values.sort((a, b) => b.date.getTime() - a.date.getTime());
    this.payrollContributions = new Array<Income>();

    values.slice(0, 4).forEach(v => {
      const aUTCMoment = moment.utc(v.date);

      if (aUTCMoment.hour() === 0) {
        console.log(aUTCMoment.valueOf(), aUTCMoment.toDate());
      }

      v.date = aUTCMoment.toDate();
      this.payrollContributions.push(v);

    });

  }

  get requestedNumberOfPayments(): number {
    return this.selectedLoan ? this.selectedLoan.requestedNumberOfPayments : 0;
  }

  get individualPaymentAmount(): number {
    if (this.selectedLoan) {
      return this.selectedLoan.amountToDiscountPerPaymentCycle;
    }
    return 0;
  }

  get expirationDate(): Date {

    if (this.selectedLoan) {
      const m = moment(this.selectedLoan.createdAt).startOf('day');
      m.add(5, 'days');
      return m.toDate();
    }

    return new Date();

  }

  get loanInterest(): number {
    return this.permanentLoanParameter.loanInterest(this.currentEmployee);
  }

  onCancel() {
    this.router.navigate(['../../'], { relativeTo: this.route });
  }

  get periodHasMoney(): boolean {

    if (this.period) {

      if (this.selectedLoan.employeeRef.activeSavingAccount === true) {

        return (this.period.investmentParameterSavers.theoreticalAvailableAmount - this.selectedLoan.requestedAmount) >= 0;

      } else {

        return (this.period.investmentParameterNonSavers.theoreticalAvailableAmount - this.selectedLoan.requestedAmount) >= 0;

      }

    }

    return false;

  }

  async rejectLoan() {

    // await this.dataSource.updateNotifications(this.currentEmployee.workInformation.supervisor.employeeNumber, -1);
    if (this.selectedLoan.restructuredID) {

      this.dataSource.markDeniedRestructuredLoan(this.selectedLoan.restructuredID).then(() => {
        this.dataSource.markAsRejectedLoan(this.selectedLoan.loanID, this.selectedLoan.comment).then(() => {
          this.router.navigate(['../../'], { relativeTo: this.route });
        });
      });

    } else {

      this.dataSource.markAsRejectedLoan(this.selectedLoan.loanID, this.selectedLoan.comment).then(() => {
        this.router.navigate(['../../'], { relativeTo: this.route });
      });

    }
  }

  setRejectedLoanComment() {

    const dialogRef = this.dialog.open(RejectDialogComponent, {
      width: '50%',
      height: '40%',
      data: this.selectedLoan
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        if (result.comment !== '') {

          const dialogConfirmation = this.dialog.open(CancelConfirmDialogComponent, {
            data: {
              message: `¿Desea enviar las siguientes solicitudes de préstamo a la Caja de Ahorro con los siguientes estatus?
          ${this.selectedLoan.employeeRef.displayName}, ${this.selectedLoan.approvedBy.displayName}, por $${this.selectedLoan.requestedAmount} - CANCELADO`,
              cancelButton: 'Cancelar',
              confirmButton: 'Aceptar'
            }
          });
          dialogConfirmation.afterClosed().subscribe(resultC => {
            if (resultC) {
              this.rejectLoan();
            }
          });

        } else {

          this.dialog.open(InfoDialogComponent, {
            data: {
              message: 'Se debe de documentar la razón por la cual se rechaza la solicitud de préstamo<br>es necesario que de clic en el botón de rechazar nuevamente e ingrese el texto.',
              close: 'Aceptar'
            }
          });

        }



      }
    });

  }

  approveLoan() {

    const dialogConfirmation = this.dialog.open(CancelConfirmDialogComponent, {
      data: {
        message: `¿Desea enviar las siguientes solicitudes de préstamo a la Caja de Ahorro con los siguientes estatus? ${this.selectedLoan.employeeRef.displayName}, ${this.selectedLoan.approvedBy.displayName}, por $${this.selectedLoan.requestedAmount} - ACEPTADO`,
        cancelButton: 'Cancelar',
        confirmButton: 'Aceptar'
      }
    });

    dialogConfirmation.afterClosed().subscribe(async result => {

      if (result) {

        if (this.currentEmployee) {

          this.ui.showSpinner();

          let nl: Loan;
          const m1 = moment();
          const nowMilSecs = m1.toDate().getTime();
          const nextPayments = this.payrollParameter.payrollDatesForLoans.filter(pd => pd.active === true && pd.startDate.getTime() >= nowMilSecs);

          nl = this.permanentLoanParameter.calculateLoan(environment.variableLoan, this.currentEmployee, this.selectedLoan.requestedNumberOfPayments, this.selectedLoan.requestedAmount, this.selectedLoan.interestPercentage, this.payrollParameter, nextPayments);

          this.selectedLoan.scheduleDates = nl.scheduleDates;
          this.selectedLoan.approvedAt = new Date();
          this.selectedLoan.approvedBy = new EmployeeRef();
          // authService
          const authUser = this.logicService.dataManager.principalDataLoader.employee && this.logicService.dataManager.principalDataLoader.employee.workInformation ? this.logicService.dataManager.principalDataLoader.employee : this.authService.authEmployee;
          if (authUser) {

            this.selectedLoan.approvedBy.employeeNumber = authUser.uid;
            this.selectedLoan.approvedBy.email = authUser.contactInformation.item('workEmail') ? authUser.contactInformation.item('workEmail').value : 'no email';
            this.selectedLoan.approvedBy.displayName = authUser.displayName;
            this.selectedLoan.approvedBy.userName = authUser.displayName;
            this.selectedLoan.approvedBy.uid = authUser.uid;

          }

          const slObj: any = this.selectedLoan.toAny();
          slObj.approvedAt = new Date();
          const sd = this.selectedLoan.scheduleDates.toObject();

          await this.dataSource.updateLoanRequest(slObj).catch(error => console.log(error));
          let status: LoanStatus = LoanStatus.ACTIVE;
          let index = 0;

          if (this.selectedLoan.type === 'permanent') {

            if (!Number.isNaN(this.selectedLoan.requestedAmount)) {
              const query = await this.dataSource.loadPendingListIndex().pipe(take(1)).toPromise();
              if (query && query.empty === false) {
                const data = query.docs[0].data();

                if (this.selectedLoan.employeeRef.activeSavingAccount == data.employeeRef.activeSavingAccount) {
                  index += data.listIndex && data.listIndex > 0 ? data.listIndex : 0;
                  
                }
              }

              if (this.periodHasMoney === false) {
                status = LoanStatus.ACTIVE_PENDING;

              } else if (this.periodHasMoney === true && index > 0) {
                status = LoanStatus.ACTIVE_PENDING;

              } else {

                await this.dataSource.saveTheoreticalAvailableAmount(this.permanentParameter.parametersID, this.selectedLoan.requestedAmount, this.selectedLoan.employeeRef.activeSavingAccount).catch(error => console.log(error));

              }

              //guardar en un log el prestamo en lista
              await this.dataSource.saveLogEmployeeLoanChanges(this.selectedLoan, 'approveLoan' + '-' + LoanStatus.ACTIVE);

              await this.dataSource.markAsApprovedLoan(this.selectedLoan.loanID, status).catch(error => console.log(error));
              this.selectedLoan.status = status;


            } else {

              this.dialog.open(CancelConfirmDialogComponent, {
                data: {
                  message: 'No fue posible realizar la aprobación del préstamo, inténtelo mas tarde',
                  cancelButton: 'Cancelar',
                  confirmButton: 'Aceptar'
                }
              });

            }

          } else {

            await this.dataSource.saveLogEmployeeLoanChanges(this.selectedLoan, 'approveLoan' + '-' + status);

            await this.dataSource.markAsApprovedLoan(this.selectedLoan.loanID, status).catch(error => {
              this.router.navigate(['../../'], { relativeTo: this.route });
            });

          }

          if (status === LoanStatus.ACTIVE) {

            this.ui.stopSpinner();
            this.dialog.open(InfoDialogComponent, {
              data: {
                message: 'El préstamo fue liberado correctamente.',
                close: 'Aceptar'
              }
            });
            /*
            const startOfDay = this.selectedLoan.convertToCDMXSEC(new Date());
            const transport = this.selectedLoan.generateTransportMessage(this.oldLoan);
            const loansArray = Object.keys(transport).map(key => transport[key]).filter(obj => obj);

            const variableLoan = environment.variableLoan;
               if (variableLoan === true) {
   
                 const transportPayments = this.selectedLoan.generateTransportPayments();
                 await this.dataSource.addAmortizationLoanObject(startOfDay, transportPayments);
   
               }*/



          } else {

            this.ui.stopSpinner();
            this.dialog.open(InfoDialogComponent, {
              data: {
                message: 'La solicitud de préstamo fue enviada a la lista de espera.',
                close: 'Aceptar'
              }
            });

          }

          this.router.navigate(['../../'], { relativeTo: this.route });

        }

      }
    });
  }

  ngOnInit() {
  }

  ngOnDestroy() {

    if (this.principalSubscription && !this.principalSubscription.closed) {
      this.principalSubscription.unsubscribe();
      this.principalSubscription = null;
    }

    if (this.parameterSubscription && !this.parameterSubscription.closed) {
      this.parameterSubscription.unsubscribe();
      this.parameterSubscription = null;
    }

  }

}
